import sdkProvider from "./sdkProvider";
import global from "global";
import { logError } from "../../monitoring";

export default ({ sdkMethod, instancePayload }) => {
  const { appMeasurementInstance } = sdkProvider();
  global.setTimeout(() => {
    try {
      Object.assign(appMeasurementInstance, {
        ...instancePayload
      });
      sdkMethod();
    } catch (e) {
      logError(e);
    }
  });
};
